import apiClient from './client';
import { Donasi, SettlementSummary } from '@/types';

export interface DonasiListParams {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  status?: number;
  transactionType?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface DonasiListResponse {
  data: Donasi[];
  total: number;
  totalAmount: number;
  page: number;
  limit: number;
}

export interface SettlementSummaryParams {
  startDate?: string;
  endDate?: string;
}

export interface MessageResponse {
  message: string;
  checked?: number;
  updated?: number;
}

export const donasiApi = {
  getAll: async (params: DonasiListParams = {}): Promise<DonasiListResponse> => {
    const response = await apiClient.get('/api/user-donasi', {
      params,
    });
    return response.data;
  },

  getById: async (id: number): Promise<Donasi> => {
    const response = await apiClient.get(`/api/user-donasi/${id}`);
    return response.data;
  },

  getSettlementSummary: async (params: SettlementSummaryParams = {}): Promise<SettlementSummary> => {
    const response = await apiClient.get('/api/user-donasi/settlement-summary', {
      params,
    });
    return response.data;
  },

  exportSettlementSummary: async (params: SettlementSummaryParams = {}): Promise<Blob> => {
    const response = await apiClient.get('/api/user-donasi/settlement-summary/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  create: async (data: Partial<Donasi>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/user-donasi', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Donasi>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/user-donasi/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/user-donasi/${id}`);
    return response.data;
  },
};
